import { render, staticRenderFns } from "./SimilarTask.vue?vue&type=template&id=0d4914c9&"
import script from "./SimilarTask.vue?vue&type=script&lang=js&"
export * from "./SimilarTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports